import ImageGallery from 'react-image-gallery';
import React,{Component} from 'react'
import "react-image-gallery/styles/css/image-gallery.css";

class MyComponent extends React.Component {
 
  render() {
 
    const images = [
      {
        original: 'https://drive.google.com/uc?export=view&id=1UciDgx8Q6dLwsfYR9CKUATB-b40852LD',
        thumbnail: 'https://drive.google.com/uc?export=view&id=1UciDgx8Q6dLwsfYR9CKUATB-b40852LD',
      },
      {
        original: 'https://drive.google.com/uc?export=view&id=1OiwRPexbcvOpnK9aWsbRpT5Ov3lZc3Ma',
        thumbnail: 'https://drive.google.com/uc?export=view&id=1OiwRPexbcvOpnK9aWsbRpT5Ov3lZc3Ma'
      },
      {
        original: 'https://drive.google.com/uc?export=view&id=1QH5Ere-PMbbRIUtubD-ozKGyz_crzRdS',
        thumbnail: 'https://drive.google.com/uc?export=view&id=1QH5Ere-PMbbRIUtubD-ozKGyz_crzRdS'
      },
      {
        original: 'https://drive.google.com/uc?export=view&id=1Hr4m0flTiv1xQrzRRcw8fy_hbbuwgDci',
        thumbnail: 'https://drive.google.com/uc?export=view&id=1Hr4m0flTiv1xQrzRRcw8fy_hbbuwgDci',
      },
      {
        original: 'https://drive.google.com/uc?export=view&id=1a5gbntAORQYydYnwvGMEekWoaK1KMLOU',
        thumbnail: 'https://drive.google.com/uc?export=view&id=1a5gbntAORQYydYnwvGMEekWoaK1KMLOU'
      },
      {
        original: 'https://drive.google.com/uc?export=view&id=1FYnv6sJCGkQO6FChvwGhqRqHjVantCHO',
        thumbnail: 'https://drive.google.com/uc?export=view&id=1FYnv6sJCGkQO6FChvwGhqRqHjVantCHO'
      },
      {
        original: 'https://drive.google.com/uc?export=view&id=1Af2cAPzA-ZWkVyH0LeYxHRNoazNeDZeQ',
        thumbnail: 'https://drive.google.com/uc?export=view&id=1Af2cAPzA-ZWkVyH0LeYxHRNoazNeDZeQ',
      },
      {
        original: 'https://drive.google.com/uc?export=view&id=1kkD2UzCZv8L1mBOQaQ9mUMGkfxZ-sR1g',
        thumbnail: 'https://drive.google.com/uc?export=view&id=1kkD2UzCZv8L1mBOQaQ9mUMGkfxZ-sR1g'
      },
      {
        original: 'https://drive.google.com/uc?export=view&id=1p0rGAeXgFshKzJPS5bJeLiWgDF4HoB4n',
        thumbnail: 'https://drive.google.com/uc?export=view&id=1p0rGAeXgFshKzJPS5bJeLiWgDF4HoB4n'
      },
      {
        original: 'https://drive.google.com/uc?export=view&id=1OOxx2kJ9ZsFA5ggnd_3TIiE9EEkWZE33',
        thumbnail: 'https://drive.google.com/uc?export=view&id=1OOxx2kJ9ZsFA5ggnd_3TIiE9EEkWZE33',
      },
      {
        original: 'https://drive.google.com/uc?export=view&id=1VDrVy9QTpNOJXEQmUNdvWDQxCK7Cv1Nx',
        thumbnail: 'https://drive.google.com/uc?export=view&id=1VDrVy9QTpNOJXEQmUNdvWDQxCK7Cv1Nx'
      },
      {
        original: 'https://drive.google.com/uc?export=view&id=18viDvomLDvSB1anyNX-X1HoFL5_V8svQ',
        thumbnail: 'https://drive.google.com/uc?export=view&id=18viDvomLDvSB1anyNX-X1HoFL5_V8svQ'
      },
      {
        original: 'https://drive.google.com/uc?export=view&id=1Rt8LlK-DUyWpNsOVrVH5UzYui42w3v1G',
        thumbnail: 'https://drive.google.com/uc?export=view&id=1Rt8LlK-DUyWpNsOVrVH5UzYui42w3v1G'
      },
      {
        original: 'https://drive.google.com/uc?export=view&id=1YSIW2Wha9nji6Fu9R2eDX0VQJ9UmvcCl',
        thumbnail: 'https://drive.google.com/uc?export=view&id=1YSIW2Wha9nji6Fu9R2eDX0VQJ9UmvcCl'
      }
    ]
 
    return (
      <ImageGallery items={images} />
    );
  }
 
}

export default MyComponent;